// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"761a27bb","455":"6cc84604","977":"b5352af7"}[chunkId] + ".chunk.js";
};